import React from 'react';

interface ModeSelectorProps {
	selectedMode: 'same_for_all' | 'different_by_card_type';
	onModeChange: (mode: 'same_for_all' | 'different_by_card_type') => void;
	/** Unique identifier for radio button group to prevent conflicts with multiple selectors */
	groupId?: string;
}

export const ModeSelector: React.FC<ModeSelectorProps> = ({
	selectedMode,
	onModeChange,
	groupId = 'default',
}) => {
	const radioGroupName = `discount_rate_mode_${groupId}`;

	return (
		<div className="space-y-4">
			{/* Same for all (3-tier) */}
			<label
				className={`flex items-start p-4 border-2 rounded-lg cursor-pointer transition-all ${
					selectedMode === 'same_for_all'
						? 'bg-purple-50 border-purple-500'
						: 'border-gray-200 bg-gray-50'
				}`}
			>
				<input
					type="radio"
					name={radioGroupName}
					value="same_for_all"
					checked={selectedMode === 'same_for_all'}
					onChange={() => onModeChange('same_for_all')}
					className="mt-1 h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300"
				/>
				<div className="ml-4 flex-1">
					<span className="font-medium text-gray-900">
						Same Discount Rate for all card types + same Authorization Fee for
						all transactions (simpler)
					</span>
				</div>
			</label>

			{/* Different for each (6-tier) */}
			<label
				className={`flex items-start p-4 border-2 rounded-lg cursor-pointer transition-all ${
					selectedMode === 'different_by_card_type'
						? 'bg-purple-50 border-purple-500'
						: 'bg-gray-50 border-white-200'
				}`}
			>
				<input
					type="radio"
					name={radioGroupName}
					value="different_by_card_type"
					checked={selectedMode === 'different_by_card_type'}
					onChange={() => onModeChange('different_by_card_type')}
					className="mt-1 h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300"
				/>
				<div className="ml-4 flex-1">
					<span className="font-medium text-gray-900">
						Different Discount Rate for different card types + different
						Authorization Fee for each card type (advanced)
					</span>
				</div>
			</label>
		</div>
	);
};
